import { BANNER_TYPE_PARAMS } from '../../constants/adfox';
import { TAdFoxBanner, IAdFoxBannerTypeParams } from '../../types/adfox';

export function getAdfoxBannerTypeParams(type: TAdFoxBanner): IAdFoxBannerTypeParams {
  return BANNER_TYPE_PARAMS[type];
}
